import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TimeZoneService {

    constructor(private http: HttpClient) { }

    query(): Observable<Timezone[]> {
        return this.http.get<Timezone[]>('/api/timezones');
    }
}

export interface Timezone {
    "key": string,
    "value": string
}